// Assets
import facebook from '@/assets/icons/logos/facebook.svg';
import linkedin from '@/assets/icons/logos/linkedin.svg';
import twitter from '@/assets/icons/logos/twitter.svg';
// Utils
import { brand } from '@/brand/brand';

export const socialMedia = (shareLink) => [
  {
    dataTag: 'buttonTw',
    buttonLogo: twitter.src,
    socialDataURL: `http://twitter.com/share?url=${shareLink}`,
    backgroundColor: '#00ACEE',
  },
  {
    dataTag: 'buttonLi',
    buttonLogo: linkedin.src,
    socialDataURL: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareLink)}`,
    backgroundColor: '#0A66C2',
  },
  {
    dataTag: 'buttonFB',
    buttonLogo: facebook.src,
    socialDataURL: `https://www.facebook.com/sharer/sharer.php?u=${shareLink}&amp;src=sdkpreparse`,
    backgroundColor: '#1877F2',
  },
];

export const modalFallback = {
  title:
    'Refer a friend by sharing this link to our exclusive, invite-only SmartWallet offer.',
  altTitle: `Share ${brand.brandName} With Friends`,
  subTitle:
    'Earn 3 FREE licensed nodes and up to $1,500.00 off the purchase of a Smart Node by sharing this exclusive offer today!',
  altSubTitle: `Share links to ${brand.brandName} content and earn points as new users sign-up,
  make purchases and participate in ${brand.brandName}’s ecosystem.`,
  primaryButton: {
    title: 'Copy Link',
    helpText: 'Copied!',
  },
};
